<template>
  <div class="treatment-plan" :class="{ 'is-mobile': isMobile }">
    <!-- 治疗方案 -->
    <div v-if="treatmentList.length > 0" class="section">
      <div class="section-header">
        <div class="section-title">治疗方案</div>
        <van-button
          v-if="showViewBtn"
          class="section-button plain"
          @click="onViewReport"
        >
          预览报告
        </van-button>
      </div>

      <div class="plan-list">
        <div
          class="plan-item"
          v-for="(plan, index) in treatmentList"
          :key="index"
        >
          <div class="plan-row">
            <div class="label">症状</div>
            <div class="value">
              <span v-if="plan.toothType === 1">全口-</span>
              <span v-else>{{ plan.fdiToothCodes }}-</span>
              <span>{{ plan.diagnosisName }}</span>
            </div>
            <div class="status" :class="'status' + plan.status">
              {{ plan.statusText }}
            </div>
          </div>
          <div class="plan-row">
            <div class="label">方案</div>
            <div class="value">{{ plan.procedureName }}</div>
          </div>
          <div class="plan-row">
            <div class="label">步骤</div>
            <div class="value row flex-wrap">
              <div
                v-for="step in plan.stepList"
                :key="step.sort"
                class="steps"
                :class="'steps' + step.status"
              >
                <span
                  v-if="step.sort > 1"
                  class="ml2 mr2 iconfont icon-arrleft"
                ></span>
                <span>{{ step.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 口内风险 -->
    <div v-if="problemTextList.length > 0" class="section">
      <div class="section-header">
        <div class="section-title">口内风险</div>
      </div>
      <div class="risk-tags">
        <div
          class="risk-tag"
          v-for="(tag, index) in problemTextList"
          :key="index"
        >
          {{ tag }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Treatment",
  props: {
    // 是否为移动端模式，默认true使用rem，false使用px
    isMobile: {
      type: Boolean,
      default: true,
    },
    // 治疗方案列表
    treatmentList: {
      type: Array,
      default: () => [],
    },
    // 口内风险列表
    problemTextList: {
      type: Array,
      default: () => [],
    },
    // 是否展示预览按钮
    showViewBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 预览方案
    onViewReport() {
      this.$emit("viewReport");
    },
  },
};
</script>

<style lang="scss" scoped>
.treatment-plan {
  // 移动端样式（使用rem）
  &.is-mobile {
    margin-bottom: 0.25rem;
    font-size: 0.292rem;

    .section {
      .section-header {
        margin-bottom: 0.167rem;

        .section-button {
          width: 1.917rem;
          height: 0.667rem;
        }
      }
    }

    .plan-list {
      .plan-item {
        padding: 0.25rem;
        margin-bottom: 0.167rem;
        border-radius: 0.083rem;

        .plan-row {
          margin-bottom: 0.083rem;
          line-height: 1.5;

          .label {
            margin-right: 0.25rem;
          }

          .status {
            height: 0.375rem;
            line-height: 0.375rem;
            font-size: 0.25rem;
            padding: 0.021rem 0.167rem;
            border-radius: 0.083rem;
            margin-left: 0.167rem;
          }
        }
      }
    }

    .risk-tags {
      gap: 0.167rem;
      padding: 0.25rem;
      border-radius: 0.083rem;

      .risk-tag {
        padding: 0.125rem 0.25rem;
        border-radius: 0.083rem;
      }
    }
  }

  // PC端样式（使用px）
  &:not(.is-mobile) {
    margin-bottom: 12px;
    font-size: 14px;

    .section {
      .section-header {
        margin-bottom: 12px;

        .section-button {
          width: 92px;
          height: 32px;
        }
      }
    }

    .plan-list {
      .plan-item {
        padding: 12px;
        margin-bottom: 12px;
        border-radius: 8px;

        .plan-row {
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 1.6;

          .label {
            margin-right: 8px;
            min-width: 36px;
          }

          .status {
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            padding: 0 8px;
            border-radius: 4px;
            margin-left: 8px;
          }
        }
      }
    }

    .risk-tags {
      gap: 8px;
      padding: 12px;
      border-radius: 8px;

      .risk-tag {
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 14px;
      }
    }
  }
}

// 通用样式
.section {
  word-break: break-all;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .section-title {
      font-weight: 500;
      color: #333;
    }

    .section-button {
      background-color: #28b8c3;
      border-color: #28b8c3;

      &.plain {
        background-color: #fff;
        color: #28b8c3;
      }
    }
  }
}

.plan-list {
  .plan-item {
    background-color: #fff;

    .plan-row {
      display: flex;

      &:last-child {
        margin-bottom: 0 !important;
      }

      .label {
        color: #666;
        flex-shrink: 0;
      }

      .value {
        flex: 1;
        text-align: left;
        word-break: break-all;

        .steps {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .steps0 {
          color: #999;
        }

        .steps1 {
          color: #ff9800;
        }

        .steps2 {
          color: #4caf50;
        }
      }

      .status {
        flex-shrink: 0;

        &.status0 {
          color: #999;
          background-color: #f5f5f5;
        }

        &.status1 {
          color: #ff9800;
          background-color: #fff3e0;
        }

        &.status2 {
          color: #4caf50;
          background-color: #e8f5e9;
        }
      }
    }
  }
}

.risk-tags {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;

  .risk-tag {
    word-break: break-all;
    background-color: #f5f5f5;
    color: #666;
  }
}
</style>
